import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import { Typography } from "@mui/material";
import { Box } from "@mui/system";

import { services } from "@services";

import { GridyList, ServiceTitle } from "./ServiceLinks.styled";

export const ServiceLinks = () => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignSelf: "flex-start",
        gap: "10px",
      }}
    >
      <Typography component="h2" variant="subtitle">
        {t("footer.services")}
      </Typography>

      <GridyList>
        {Object.entries(services[locale as "pl" | "en"]).map(
          ([slug, serviceData]) => {
            const service = serviceData as any;

            return (
              <li key={slug}>
                <Link href={`/services/${slug}`}>
                  <ServiceTitle>
                    {service?.title || slug.replace(/_/g, " ")}
                  </ServiceTitle>
                </Link>
              </li>
            );
          },
        )}
      </GridyList>
    </Box>
  );
};
